module.exports = __webpack_public_path__ + "static/media/flags_COL.ea70bab6.svg";